import { IncomingSoapAlertState, IncomingSoapAlertFilterFields, ColumnOptions, GridConfiguration,IncomingSoapAlertRecordsSearchGridData } from './incoming_soap_alert.model';


export const SEARCH_INCOMING_SOAP_ALERT_RECORDS = 'SEARCH_INCOMING_SOAP_ALERT_RECORDS';
export const GET_INCOMING_SOAP_ALERT_RECORDS = 'GET_INCOMING_SOAP_ALERT_RECORDS';
export const RESET_INCOMING_SOAP_ALERT_GRID_DATA = 'RESET_INCOMING_SOAP_ALERT_GRID_DATA';
export const RESET_INCOMING_SOAP_ALERT_RECORDS_TO_INITIAL_STATE = 'RESET_INCOMING_SOAP_ALERT_RECORDS_TO_INITIAL_STATE';

export const emptyString: string = "";

const incomingSoapAlertFilterFields: IncomingSoapAlertFilterFields = {
    patientName: emptyString,
    soapStatus: false
};

const columnOptions: ColumnOptions[] = [
    { header: 'From', field: 'From', sortable: true },
    { header: 'Received On', field: 'DATEADDED', sortable: true },  
    { header: 'Patient Name', field: 'PATIENTNAME', sortable: true } 
];

export const gridConfiguration: GridConfiguration = {
    page: 1,
    pageSize: 5,
    sort: "ALERT_ID",
    order: 1
};
const incomingSoapAlertRecordsSearchGridData: IncomingSoapAlertRecordsSearchGridData = {
    rows: 5,
    rowsPerPageOptions: [5, 10, 20],
    cols: columnOptions,
    pageLinks: 3,
    configuration: gridConfiguration,
    filterData: [],
    totalRecords: 0
};

export const initialState: IncomingSoapAlertState = {
    incomingSoapAlertFilterFields: incomingSoapAlertFilterFields,
    incomingSoapAlertRecordsSearchGridData: incomingSoapAlertRecordsSearchGridData
};
